import { render, staticRenderFns } from "./prompt-dialog.vue?vue&type=template&id=1c3afaad"
import script from "./prompt-dialog.vue?vue&type=script&lang=js"
export * from "./prompt-dialog.vue?vue&type=script&lang=js"
import style0 from "./prompt-dialog.vue?vue&type=style&index=0&id=1c3afaad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports